// PREZENCE — Printable Leave Application Form (LAF)
// Opens a print-ready window laid out like the official paper form,
// auto-filled from Prezence data. Works for employee, HR and admin.
const td = 'padding:6px 8px;border:1px solid #333;font-size:12px;';
const fmt = d => d ? new Date(d).toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}) : '';

export default function printLAF(leave, user, statement = null) {
  const u = user || leave.users || leave.user || {};
  const typeName = leave.leave_types?.name || leave.leave_type?.name || '';
  const TYPES = ['Casual Leave','Sick Leave','Earned Leave','Compensatory Leave','Maternity Leave','Leave without pay'];
  const stmtRows = (statement && statement.length ? statement : TYPES.map(t => ({ type:t })))
    .map(r => `<tr>
      <td style="${td}">${r.type || r.name || ''}</td>
      <td style="${td};text-align:center">${r.total ?? ''}</td>
      <td style="${td};text-align:center">${r.availed ?? ''}</td>
      <td style="${td};text-align:center">${r.balance ?? ''}</td>
      <td style="${td};text-align:center">${(r.type||r.name) === typeName ? (leave.total_days ?? '') : ''}</td>
      <td style="${td}"></td>
    </tr>`).join('');

  const tick = t => (t === typeName ? '☑' : '☐');
  const halfDay = leave.is_half_day ? ` — Half Day (${leave.half_day_session || 'morning'})` : '';

  const html = `<!DOCTYPE html><html><head><title>Leave Application Form</title>
  <style>
    @media print { @page { size: A4; margin: 16mm; } }
    body { font-family: Georgia, 'Times New Roman', serif; color:#111; margin:24px; }
    .head { text-align:center; margin-bottom:10px; }
    .head h1 { font-size:20px; margin:0; letter-spacing:0.5px; }
    .head h2 { font-size:14px; margin:4px 0 0; font-weight:normal; }
    .line { display:inline-block; border-bottom:1px dotted #444; min-width:180px; padding:0 6px 1px; font-weight:600; }
    .row { margin:9px 0; font-size:13px; }
    table { border-collapse:collapse; width:100%; margin:8px 0; }
    th { padding:6px 8px; border:1px solid #333; font-size:11px; background:#f0f0f0; text-transform:uppercase; letter-spacing:0.05em; }
    .sig { display:flex; justify-content:space-between; margin-top:44px; gap:16px; }
    .sig div { flex:1; text-align:center; font-size:11.5px; border-top:1px solid #333; padding-top:5px; }
    .approve { margin-top:22px; display:flex; justify-content:space-between; font-size:12.5px; }
    .foot { text-align:center; margin-top:34px; font-size:11px; color:#555; }
    .section-title { font-size:12px; font-weight:700; margin:16px 0 4px; text-transform:uppercase; letter-spacing:0.06em; }
    .status { margin-top:6px; font-size:12px; }
  </style></head><body>
  <div class="head">
    <h1>Prelegant Technologies Private Limited</h1>
    <h2>LEAVE APPLICATION FORM (LAF)</h2>
  </div>

  <div class="row">Name: <span class="line">${u.full_name || ''}</span>&nbsp;&nbsp; Designation: <span class="line">${u.designation || ''}</span></div>
  <div class="row">Section: <span class="line">${leave.section || ''}</span>&nbsp;&nbsp; Department: <span class="line">${u.department || ''}</span></div>
  <div class="row">Reason of Leave: <span class="line" style="min-width:420px">${leave.reason || ''}</span></div>
  <div class="row">Period of Leave&nbsp; From <span class="line" style="min-width:120px">${fmt(leave.from_date)}</span>
     To <span class="line" style="min-width:120px">${fmt(leave.to_date)}</span>
     Days <span class="line" style="min-width:70px">${leave.total_days ?? ''}${halfDay}</span></div>
  <div class="row">Contact During Leave: <span class="line">${leave.contact_during_leave || ''}</span></div>

  <div class="section-title">To be filled by HR / Admin Department — Leave Statement for the year</div>
  <table>
    <tr><th>Type</th><th>Total</th><th>Availed</th><th>Balance</th><th>Applied</th><th>Remarks</th></tr>
    ${stmtRows}
  </table>

  <div class="row"><b>Type of Leave (Please Tick):</b>&nbsp;
    ${TYPES.slice(0,3).map(t => `${tick(t)} ${t}`).join(' &nbsp; ')} &nbsp; ${TYPES.slice(3).some(t=>t===typeName) ? '☑' : '☐'} Others
  </div>
  <div class="row">Duties will be carried out by: <span class="line" style="min-width:320px">${leave.duty_handover_user?.full_name || leave.duty_handover_notes || ''}</span></div>
  <div class="row">Remarks (if any): <span class="line" style="min-width:420px">${leave.review_notes || ''}</span></div>
  <div class="status"><b>Status:</b> ${String(leave.status || 'pending').toUpperCase()} ${leave.reviewed_at ? `on ${fmt(leave.reviewed_at)}` : ''}</div>

  <div class="approve">
    <span>Recommended / Not Recommended (HOD)</span>
    <span>Approved / Not Approved</span>
  </div>
  <div class="sig">
    <div>Date &amp; Signature of Applicant</div>
    <div>HR &amp; Admin Executive</div>
    <div>Head of Department</div>
    <div>Head of HR &amp; Admin</div>
    <div>Chairman / Managing Director</div>
  </div>

  <div class="foot">43, Jamalkhan, Chattogram. · Generated by Prezence on ${new Date().toLocaleDateString('en-GB')}</div>
  <script>window.onload = () => window.print();</script>
  </body></html>`;

  const w = window.open('', '_blank', 'width=880,height=1000');
  if (!w) return alert('Please allow pop-ups to print the LAF');
  w.document.write(html);
  w.document.close();
}
